export default "__VITE_ASSET__BY3qOOEe__"